import styled from 'styled-components/macro'
import tw, { theme } from 'twin.macro'

export const MedicalAffairsContainer = styled.a`
  ${tw`col-span-4 order-3 lg:col-span-4 lg:row-span-1 lg:order-4`};
  display: flex;
  height: 300px;
  justify-content: center;
  margin: 0 auto;
  max-width: 290px;
  position: relative;
  width: 290px;
  @media screen and (min-width: 1024px) {
    height: 340px;
    margin: 7em auto auto auto;
  }
  @media screen and (min-width: 1250px) {
    margin: 5em auto auto auto;
  }
  .medicalaffairs_hover {
    font-size: 26px;
  }
`

export const MedicalAffairsShape = styled.div`
  background: ${props => props.hovering ? theme`colors.salmon` : theme`colors.skyblue`};
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  cursor: pointer;
  height: 100%;
  margin-top: 1em;
  position: absolute;
  transition: 1s;
  right: 0;
  top: 0;
  width: 100%;
  @media screen and (min-width: 1024px) {
    height: calc(100% - 4em); 
    margin-top: 4em;
  }
`

export const MedicalAffairsText = styled.p`
  color: ${theme`colors.royalblue`};
  cursor: pointer;
  font-size: 30px;
  font-style: italic; 
  font-weight: 100;
  position: absolute;
  text-align: center;
  top: 90px;
  width: 85%;
  left: 7.5%;
  @media screen and (min-width: 1024px) {
    top: 150px;
  }
`